export default __webpack_public_path__ + "static/media/2-icon.9a3050ab.svg";